//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppFooterNav',

  props: {
    title: {
      type: String,
      required: true
    },

    items: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showMenu: false
    }
  },

  computed: {
    shownItems() {
      return this.items.filter(i => !i.hide)
    }
  },

  watch: {
    $route: 'close'
  },

  methods: {
    toggle() {
      this.showMenu = !this.showMenu
    },

    close() {
      this.showMenu = false
    }
  }
}
